export const PROFILE_PAGE_EVENTS = {
	PROFILE_CARD_IMAGE_CLICKED: 'PROFILE_CARD_IMAGE_CLICKED',
	SAVE: 'Save',
}